// Module
var code = "<div> <i-code-prompt [isOnboardingFlow]=\"isOnboardingFlow\" [isNewChangePasswordModals]=\"isNewChangePasswordModals\"></i-code-prompt> </div> ";
// Exports
module.exports = code;